/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Since_WeekInputs */

const en_us2_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less than a week`)
};

const pt_br2_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 1 semana`)
};

const es_419_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de una semana`)
};

const pt_pt2_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 1 semana`)
};

const fr_fr2_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins d'une semaine`)
};

const de_de2_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit weniger als einer Woche`)
};

const it_it2_profile_editors_pain_since_week = /** @type {(inputs: Profile_Editors_Pain_Since_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da meno di una settimana`)
};

/**
* | output |
* | --- |
* | "Less than a week" |
*
* @param {Profile_Editors_Pain_Since_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_since_week = /** @type {((inputs?: Profile_Editors_Pain_Since_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Since_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_since_week(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_since_week(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_since_week(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_since_week(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_since_week(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_since_week(inputs)
	return en_us2_profile_editors_pain_since_week(inputs)
});
export { profile_editors_pain_since_week as "profile-editors.pain_since_week" }